import { DEFAULT_VALUE } from "../types/LoggingTypes";
export class UserDimensions {
    constructor() {
        this._userTrackingId = DEFAULT_VALUE;
        this._userType = DEFAULT_VALUE; //missing
        this._userTargetId = DEFAULT_VALUE;
        this._userTargetType = DEFAULT_VALUE; //missing
        this._userMemberId = DEFAULT_VALUE;
    }
    static getInstance() {
        if (!UserDimensions.instance) {
            UserDimensions.instance = new UserDimensions();
        }
        return UserDimensions.instance;
    }
    get userAuth() {
        return this._userMemberId === DEFAULT_VALUE ? 'LoggedOut' : 'LoggedIn';
    }
    get userMemberId() {
        return this._userMemberId;
    }
    set userMemberId(_userMemberId) {
        this._userMemberId = _userMemberId;
    }
    get userTargetId() {
        return this._userTargetId;
    }
    set userTargetId(_userTargetId) {
        this._userTargetId = _userTargetId;
    }
    get userTargetType() {
        return this._userTargetType;
    }
    get userAbbucket() {
        return DEFAULT_VALUE;
    }
    get userType() {
        return this._userType;
    }
    get userTrackingId() {
        return this._userTrackingId;
    }
    set userTrackingId(_userTrackingId) {
        this._userTrackingId = _userTrackingId;
    }
    reset() {
        this._userTargetId = DEFAULT_VALUE;
    }
}
